module.exports = __webpack_public_path__ + "components/country-flag/static/gl-135057cf7057a139a6c97f7c90e482ee.svg";